import './App.css';
import Aos from 'aos';
import 'aos/dist/aos.css'
import Hero from '../src/components/hero/Hero'
import Stats from './components/stats/Stats';
import Why from './components/stats/Why';
import Services from './components/sections/Services';
import Header from "./components/header/Header";


import { useEffect, useState } from 'react';
import Calculate from './components/sections/Calculate';
import Gallery from './components/sections/Gallery';
import Testimonials from './components/sections/Testimonials';
import Footer from './components/sections/Footer';
function App() {
   //aos init
  useEffect(() => {
    Aos.init({
      duration: 2500,
      delay: 400,
    });
  }
  );

  return (
    <div>
      <Header/>
      <Hero />
      <Stats />
      <Why />
      {/* <Calculate /> */}
      <Services />
      <Gallery />
      <Testimonials />
      <Footer />

    </div>
  );
}

export default App;
